import type { Prototype } from "../prototype-types";

export const geoffBeresfordPrototypes: Prototype[] = [
  {
    id: "ads-profit-calculator",
    name: "Ads profit calculator",
    path: "/gb/ads-profit-calculator",
    description:
      "Collect profit margin from brands to surface payback period estimates on ads acquired retailers.",
    owner: "Geoff Beresford",
    createdAt: "2026-03-05",
    lastUpdated: "2026-03-05",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5b0c07e7d62275f8eb2420eff315e3fffc963e7c80ffec11abce42748f50b50c.png",
    creationTool: "cursor",
  },
];
